import { useStateMachine } from "components/context/stateMachine/StateMachineContext"
import { Steps } from "components/csd-enrollment/workflow/steps"
import React from "react"
import { Body, BodySmall } from "components/views/atoms/Bodies"
import { Container, FlexContainer, H2, TextLink } from "@carrotfertility/carotene"
import { IlloBlocks } from "../../../views/atoms/Illustrations"
import { useProgressTracker } from "../../../views/modal/ProgressTracker"
import { BenefitEnrollmentModalContinueButton } from "../../shared"
import { useBenefitEnrollment } from "components/context/enrollment/BenefitEnrollmentContext"
import { Spacer } from "components/views/atoms/Atoms"

interface InformationalConnectionInsuranceStepProps {
  stepHeader: string
  stepBody: string
  viewName: typeof Steps[keyof typeof Steps]
}

function InformationalConnectionInsuranceStep({
  stepHeader,
  viewName,
  stepBody
}: InformationalConnectionInsuranceStepProps): JSX.Element {
  const { setNextStep } = useStateMachine(viewName, null)
  const { companyHasCSDEnabled } = useBenefitEnrollment()
  useProgressTracker(2, "CONNECT YOUR INSURANCE")

  function onClickContinue(): void {
    setNextStep(viewName, "")
  }

  return (
    <div>
      <Spacer height={3} />
      <FlexContainer justifyContent="center" padding="none" stack="medium">
        <IlloBlocks />
      </FlexContainer>
      <H2 stack="tiny" variant="dark">
        {stepHeader}
      </H2>
      <Container padding="none" stack="huge">
        <Body color="black-80">{stepBody}</Body>
      </Container>
      <FlexContainer padding="none" justifyContent={companyHasCSDEnabled ? "space-between" : "flex-end"}>
        {companyHasCSDEnabled && (
          <div>
            <TextLink onClick={(): void => setNextStep(viewName, "skip")}>
              <BodySmall color="black-80">Skip section</BodySmall>
            </TextLink>
          </div>
        )}
        <BenefitEnrollmentModalContinueButton onClick={onClickContinue} />
      </FlexContainer>
    </div>
  )
}

export function InformationalConnectPartnerInsuranceStep(): JSX.Element {
  return (
    <InformationalConnectionInsuranceStep
      viewName={Steps.PARTNER_INFO_CONNECT_INSURANCE}
      stepHeader="Next, connect your Carrot account to your partner's health insurance provider."
      stepBody="If they have a deductible, Carrot talks to their insurance provider about any out-of-pocket payments made and submitted through Carrot. These payments get added to the other deductible payments, which means paying down the deductible faster."
    />
  )
}

export function InformationalConnectMemberInsuranceStep(): JSX.Element {
  return (
    <InformationalConnectionInsuranceStep
      viewName={Steps.MEMBER_INFO_CONNECT_INSURANCE}
      stepHeader="Next, connect your Carrot account with your health insurance provider."
      stepBody="If you have a deductible, Carrot talks to your insurance provider about any out-of-pocket payments you make and submit through Carrot. These payments get added to your other deductible payments, meaning you can pay down your deductible faster."
    />
  )
}
